import { useGetUserAuthTxs as useGetUserAuthTxsQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetUserAuthTxsProps = {
  cardId: number;
  pageNum?: number;
  pageSize?: number;
  orderNo?: string;
  startTime?: number;
  endTime?: number;
  type?: 'AUTH' | 'REFUND' | 'VERIFICATION' | 'VOID' | 'MAINTAIN_FEE';
};

/* Hook */
export const useGetUserAuthTxs = ({
  cardId,
  pageNum = 1,
  pageSize = 10,
  orderNo,
  startTime,
  endTime,
  type,
}: UseGetUserAuthTxsProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { data, isLoading, isError, error } = useGetUserAuthTxsQuery({
    enabled: !!id && !!cardId,
    userId: id ?? 0,
    cardId: cardId ?? 0,
    requestData: {
      pageNum,
      pageSize,
      orderNo,
      startTime,
      endTime,
      type,
    },
  });

  /* Return */
  return {
    isLoading,
    isError,
    error,
    total: data?.total,
    records: data?.records,
  };
};
